<template>
  <div
    v-if="visible"
    class="preview-modal fixed inset-0 bg-black/20 backdrop-blur-sm flex items-center justify-center z-50"
    @click.self="close"
  >
    <div
      class="preview-modal-shell bg-white shadow-[0_-1px_0_rgba(164,179,190,0.25)] flex flex-col overflow-auto"
      style="
        width: 21cm;
        max-width: calc(100vw - 32px);
        height: calc(100vh - 80px);
        border-radius: var(--radius);
      "
    >
      <TipTapEditor2
        mode="preview"
        :with-border="false"
        :templateLang="templateLang"
        :json="templateJson"
        @change:lang="changeLang"
        ref="editorRef"
      />
    </div>
  </div>
</template>

<script>
import TipTapEditor2 from "./TipTapEditor2.vue";

export default {
  name: "ConfirmationModal",
  components: { TipTapEditor2 },
  props: {
    templateLang: {
      type: String,
      required: true,
    },
    templateJson: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  emits: ["close", "cancel", "confirm"],
  methods: {
    async open() {
      let resolve;
      let reject;
      const popupPromise = new Promise((ok, fail) => {
        resolve = ok;
        reject = fail;
      });
      this.$options.popupController = { resolve, reject };

      this.visible = true;

      return popupPromise;
    },
    close() {
      this.$options.popupController &&
        this.$options.popupController.resolve({
          action: "close",
        });
      this.visible = false;
    },
    reset() {
      this.visible = false;
    },
    reject() {
      this.close();
      this.reset();
    },
    confirm() {
      this.$options.popupController &&
        this.$options.popupController.resolve({
          action: "confirm",
        });
      this.reset();
    },
    changeLang(lang) {
      this.$emit("change:lang", lang);
    },
  },
};
</script>

<style lang="scss">
.preview-modal {
  .page.a4 {
    margin: 0 !important;
    width: 100% !important;
    max-width: 100% !important;
    min-height: 0 !important;
    box-shadow: none !important;
    border-radius: 0 !important;
  }

  .editor-shell {
    border: 0 !important;
    border-radius: 0 !important;
  }

  .tiptap-wrapper {
    @apply p-0 !important;
  }
}
</style>
